import type { ChainConfig, Environment } from "../types";
import { BASE_MAINNET_TOKENS, ETHEREUM_MAINNET_TOKENS, POLYGON_MAINNET_TOKENS } from "./tokens";

export const DEFAULT_CHAIN_IDS: Record<Environment, number> = {
  mainnet: 8453,
  testnet: 84532,
};

export const CHAIN_REGISTRIES: Record<Environment, Record<number, ChainConfig>> = {
  mainnet: {
    8453: {
      environment: "mainnet",
      chainId: 8453,
      name: "Base",
      rpcUrl: "https://mainnet.base.org",
      factoryAddress: "0x8fa50DeA8DB10987D7d22ac092001c3613C18779",
      wethAddress: "0x4200000000000000000000000000000000000006",
      blockExplorerUrl: "https://basescan.org",
      tokens: BASE_MAINNET_TOKENS,
    },
    137: {
      environment: "mainnet",
      chainId: 137,
      name: "Polygon",
      rpcUrl: "https://polygon-bor-rpc.publicnode.com",
      factoryAddress: "0x8fa50DeA8DB10987D7d22ac092001c3613C18779",
      wethAddress: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
      blockExplorerUrl: "https://polygonscan.com",
      tokens: POLYGON_MAINNET_TOKENS,
    },
    1: {
      environment: "mainnet",
      chainId: 1,
      name: "Ethereum",
      rpcUrl: "https://ethereum-rpc.publicnode.com",
      factoryAddress: "0x8fa50DeA8DB10987D7d22ac092001c3613C18779",
      wethAddress: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      blockExplorerUrl: "https://etherscan.io",
      tokens: ETHEREUM_MAINNET_TOKENS,
    },
  },
  testnet: {
    84532: {
      environment: "testnet",
      chainId: 84532,
      name: "Base Sepolia",
      rpcUrl: "",
      factoryAddress: "0x0000000000000000000000000000000000000000",
      wethAddress: "0x0000000000000000000000000000000000000000",
      blockExplorerUrl: "https://sepolia.basescan.org",
      tokens: [],
    },
  },
};
